import { useTranslation } from 'react-i18next';
import { ButtonProps as MuiButtonProps } from '@mui/material/Button';
import Button from '../../../../../../shared/library/Button';
import Typography from '../../../../../../shared/library/Typography';
import { StyledCloseIcon } from './styles';

export interface SelectionResetButtonProps extends MuiButtonProps {}

export default function SelectionResetButton(props: SelectionResetButtonProps) {
  const { children, ...buttonProps } = props;
  const { t } = useTranslation();

  return (
    <Button {...buttonProps} variant="text">
      <StyledCloseIcon fontSize="small" sx={{ mr: 0.5 }} />
      <Typography variant="caption1" paletteColorName="brandPrimary">
        {children ||
          t(
            'site.pricing.products-selection.selection-reset-button.remove-add-on.label',
          )}
      </Typography>
    </Button>
  );
}
